module.exports = {"id":"213846","name":"Cristián Suárez","rating":"71","photo":"./data/images/photos/4/213846.png","club":{"name":"CD Everton","logo":"./data/images/clubs/CDEverton.png"},"positions":["DC","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CristianSuarez0.json
// module id = 882
// module chunks = 0